export enum AlertLevel {
    error = 'error',
}

export interface Alert {
    title?: string;
    message: string;
    level?: AlertLevel;
}
